var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deadline)?_c('div',{class:['fix-board', ("fix-board_theme_" + _vm.theme)]},[_vm._v("\n    "+_vm._s(_vm.deadline)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }